import React, { useState, useEffect } from 'react'
import {
  Button,
  Badge
} from '@heroui/react'
import { BellIcon } from 'lucide-react'
import { useUser } from '../../contexts/UserContext'
import { useNavigate } from 'react-router-dom'
import V2BoardAPI from '../../services/api';
import { getNotices } from '../../services/notice';
import toast from 'react-hot-toast'

const NotificationPanel = () => {
  const { user } = useUser()
  const navigate = useNavigate()
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    if (user) {
      fetchNoticesCount()
    }
  }, [user])

  const fetchNoticesCount = async () => {
    if (!user) return

    try {
      const api = new V2BoardAPI(user.baseUrl, user.token)
      const data = await getNotices(api);

      // 计算未读通知数量（这里简单地显示所有可见的通知）
      const visibleNotices = data?.filter(notice => notice.show) || []
      setUnreadCount(visibleNotices.length)
    } catch (error) {
      console.error('Failed to fetch notices count:', error)
      // 静默失败，不显示错误提示
    }
  }

  const handleNotificationClick = () => {
    navigate('/notifications')
  }

  return (
    <div>
      <Badge
        content={unreadCount > 0 ? unreadCount : null}
        color="danger"
        size="sm"
        className="border-2 border-white dark:border-gray-900"
      >
        <Button
          isIconOnly
          variant="light"
          size="sm"
          className="text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          onClick={handleNotificationClick}
          aria-label="查看通知"
        >
          <BellIcon className="w-4 h-4" />
        </Button>
      </Badge>
    </div>
  )
}

export default NotificationPanel
